<template>
  <video controls preload="lazy" :poster="previewUrl" class="object-cover">
    <source :src="proxyUrl" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
</template>

<script setup lang="ts">
// TODO: Fix playing of uploaded videos, they can be proxied on cloudinary
import { computed } from 'vue'

const props = defineProps({
  url: String,
  cmsBasePath: { type: String, default: 'https://cms.djurensratt.se' },
  cloudName: { type: String, default: 'djurensratt' },
})

const proxyUrl = computed(() => {
  if (!props.url) return ''
  const baseUrl = props.url.startsWith('http') ? props.url : props.cmsBasePath + props.url
  return `https://res.cloudinary.com/${props.cloudName}/video/fetch/${baseUrl}`
})

const previewUrl = computed(() => {
  if (!props.url) return ''
  const baseUrl = props.url.startsWith('http') ? props.url : props.cmsBasePath + props.url
  return `https://res.cloudinary.com/${props.cloudName}/video/fetch/e_preview,f_png/${baseUrl}`
})
</script>
